'use client';

import { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
// Configure Mapbox if needed
if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_MAPBOX_API_KEY) {
  mapboxgl.accessToken = process.env.NEXT_PUBLIC_MAPBOX_API_KEY || '';
}

const MapboxTouchFix: React.FC = () => {
  useEffect(() => {
    // Original touchmove handler in Mapbox
    const originalAddEventListener = Element.prototype.addEventListener;

    // Override addEventListener for all elements
    Element.prototype.addEventListener = function (
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ): void {
      if (type === 'touchmove') {
        options = { passive: true, ...(typeof options === 'object' ? options : {}) };
      }
      return originalAddEventListener.call(this, type, listener, options);
    };

    return () => {
      // Restore original method when component unmounts
      Element.prototype.addEventListener = originalAddEventListener;
    };
  }, []);

  return null;
};

export default MapboxTouchFix;